import React from "react";
import { LostUnitsForm } from "./LostUnitsForm";

export const LostUnitsCreate: React.FC = () => {
  return (
    <div>
      <LostUnitsForm />
    </div>
  );
};
